import { useEffect, useState } from "react";
import { Loader2, Play } from "lucide-react";

import { reMedia } from "@/lib/docstate";

// Extract a YouTube video id from a watch/share/embed url.
const ytId = (url = "") => {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/)([A-Za-z0-9_-]{6,})/);
  return m ? m[1] : "";
};
// Extract a Spotify embed path from a share url.
const spotifyEmbed = (url = "") => {
  const m = url.match(/open\.spotify\.com\/(episode|show|playlist|track)\/([A-Za-z0-9]+)/);
  return m ? `https://open.spotify.com/embed/${m[1]}/${m[2]}` : "";
};

export default function DocstateMedia({ kind }) {
  const [items, setItems] = useState(null);
  const isVideo = kind === "video";

  useEffect(() => { window.scrollTo(0, 0); setItems(null); reMedia(kind).then(setItems).catch(() => setItems([])); }, [kind]);

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid={`docstate-media-${kind}`}>
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">{isVideo ? "Watch" : "Listen"}</p>
        <h1 className="ds-display mt-2 text-4xl font-medium text-white sm:text-5xl">{isVideo ? "Property Films & Tours" : "The Docstate Podcast"}</h1>
        <p className="mt-4 max-w-2xl text-lg font-light text-[#C9BBB2]">
          {isVideo ? "Cinematic walkthroughs and buyer tours across Dubai's finest communities." : "Conversations on Dubai property, investment and lifestyle."}
        </p>

        {!items ? (
          <div className="mt-16 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" /></div>
        ) : items.length ? (
          <div className={`mt-12 grid gap-8 ${isVideo ? "md:grid-cols-2" : "lg:grid-cols-2"}`}>
            {items.map((m) => {
              const vid = ytId(m.url);
              const spot = spotifyEmbed(m.url);
              return (
                <div key={m.id} className="ds-card overflow-hidden" data-testid={`media-${m.id}`}>
                  {isVideo && vid ? (
                    <div className="aspect-video w-full">
                      <iframe className="h-full w-full" src={`https://www.youtube.com/embed/${vid}`} title={m.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                    </div>
                  ) : !isVideo && spot ? (
                    <iframe className="w-full" style={{ height: 232 }} src={spot} title={m.title} allow="encrypted-media" loading="lazy" />
                  ) : (
                    <div className="relative aspect-video w-full">
                      <img src={m.thumbnail} alt={m.title} className="h-full w-full object-cover" />
                      <div className="absolute inset-0 flex items-center justify-center bg-black/40"><Play className="h-12 w-12 text-[#F3E5AB]" /></div>
                    </div>
                  )}
                  <div className="p-5">
                    <h2 className="ds-display text-lg text-white">{m.title}</h2>
                    {m.description && <p className="mt-1 text-sm font-light text-[#9D8D83]">{m.description}</p>}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="mt-12 text-sm font-light text-[#9D8D83]">New {isVideo ? "videos" : "episodes"} coming soon.</p>
        )}
      </div>
    </div>
  );
}
